module.exports = __webpack_public_path__ + "files/b0c6c8353ed8a094373cfccb3b085d7c.png";